import {useEffect, useRef, useState} from "react";
import {Alert, Button, Card} from "react-bootstrap";
import {Link, useSearchParams} from "react-router";
import {NewsApi} from "../../api/NewsApi";
import {ErrorAlert} from "../../components/ErrorAlert";
import {LoadingSpinner} from "../../components/LoadingSpinner";
import {usePageTitle} from "../../components/usePageTitle";
import {format, language, news} from "../../i18n";

const messages = news.confirm;
const andList = new Intl.ListFormat(language, { type: 'conjunction' });

// Opened from the mailing list's confirmation email: /news/confirm?token=… (double opt-in: this is what adds the address).
export function NewsConfirmPage() {
    const [params] = useSearchParams();
    const token = params.get('token') ?? '';
    const [result, setResult] = useState<{ products: { sku: string, name: string }[], news: boolean }>();
    const [error, setError] = useState<unknown>();
    const started = useRef(false);
    usePageTitle(messages.title);

    useEffect(() => {
        // Once only (StrictMode runs effects twice).
        if (!token || started.current) {
            return;
        }
        started.current = true;
        NewsApi.confirm(token).then(setResult, setError);
    }, [token]);

    return (
        <Card className="auth-card mx-auto mt-md-4">
            <Card.Body className="p-4">
                <h1 className="h4 mb-3">{messages.title}</h1>
                {!token && <Alert variant="warning">{messages.noToken}</Alert>}
                {token && !result && !error && <LoadingSpinner/>}
                {result && (
                    <>
                        <Alert variant="success" role="status">
                            {format(result.news ? messages.doneWithNews : messages.done, { products: andList.format(result.products.map(x => x.name)) })}
                        </Alert>
                        <Button as={Link as any} to="/products" variant="outline-primary">{messages.products}</Button>
                    </>
                )}
                <ErrorAlert error={error} messages={{ 404: messages.expired }}/>
            </Card.Body>
        </Card>
    );
}
